import React from 'react';
import { KPICard } from '@/components/ui';
import type { ReworkStats } from '../types/construction-rework.types';

interface Props {
  stats?: ReworkStats;
  isLoading?: boolean;
}

export const ReworkKPIBoard: React.FC<Props> = ({ stats, isLoading }) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 mb-6">
      <KPICard
        title="Tổng lệnh sửa lỗi"
        value={stats?.totalOrders || 0}
        icon="ri-tools-line"
        variant="primary"
        isLoading={isLoading}
      />
      <KPICard
        title="Chưa hoàn thành"
        value={stats?.openCount || 0}
        icon="ri-time-line"
        variant="warning"
        isLoading={isLoading}
      />
      <KPICard
        title="Lỗi nghiêm trọng"
        value={stats?.criticalCount || 0}
        icon="ri-error-warning-line"
        variant="danger"
        isLoading={isLoading}
      />
      <KPICard
        title="Tổng chi phí"
        value={new Intl.NumberFormat('vi-VN', { style: 'currency', currency: 'VND' }).format(stats?.totalActualCost || 0)}
        icon="ri-money-dollar-circle-line"
        variant="info"
        isLoading={isLoading}
      />
    </div>
  );
};
